<template>
  <!-- eslint-disable max-len -->
  <div class="bpc-resources">
    <bpc-page-top :breadcrumb=breadcrumb :links=links></bpc-page-top>
    <bpc-page-title :heading=heading :subheading=subheading :avatar=avatar :icon=icon :actions="actions" :selection=selection>
      <b-button  class="ml-2" v-b-modal.modal-create-resource variant="success">
        <font-awesome-icon class="mr-2" icon="plus"/>Create New</b-button>
    </bpc-page-title>
    <b-card _title="Example" class="main-card mb-4">
      <bpc-table :items=items :fields=fields :selection=selection :filters=filters @update-selection="updateSelection"></bpc-table>
    </b-card>
    <b-modal id="modal-create-resource" size="lg" title="Create resource">
      <bpc-form-create-resource></bpc-form-create-resource>
      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="show=false">Cancel</b-button>
        <b-dropdown variant="primary" @click="show=false" right split text="Save">
          <b-dropdown-item @click="show=false">Save & Edit</b-dropdown-item>
          <b-dropdown-item>Save & New</b-dropdown-item>
        </b-dropdown>
      </template>
    </b-modal>
  </div>
</template>


<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faPlus,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import BpcPageTop from '@/mockups/layouts/components/BpcPageTop.vue';
import BpcPageTitle from '@/mockups/layouts/components/BpcPageTitle.vue';
import BpcTable from '@/mockups/tables/BpcTable.vue';
import BpcFormCreateResource from '@/mockups/forms/BpcFormCreateResource.vue';

library.add(
  faPlus,
);

import img1 from '../../assets/resources/1.jpg';
import img2 from '../../assets/resources/2.jpg';
import img3 from '../../assets/resources/3.jpg';
import img4 from '../../assets/resources/4.jpg';
import img5 from '../../assets/resources/5.jpg';
import img6 from '../../assets/resources/6.png';
import img7 from '../../assets/resources/7.jpg';
import img8 from '../../assets/resources/8.jpg';

const items = [
  {
    id: 1,
    checked: false,
    code: 'H1',
    name: 'Hall 1',
    type: 'infrastructure',
    status: 'active',
    img_url: img5,
    parent_id: null,
    color: '#f7b924',
  },
  {
    id: 2,
    checked: false,
    code: 'H1-A',
    name: 'Hall 1 - A',
    type: 'infrastructure',
    status: 'active',
    img_url: img5,
    parent_id: 1,
    color: '#f7b924',
  },
  {
    id: 3,
    checked: false,
    code: 'H1-B',
    name: 'Hall 1 - B',
    type: 'infrastructure',
    status: 'active',
    img_url: img5,
    parent_id: 1,
    color: '#f7b924',
  },
  {
    id: 4,
    checked: false,
    code: 'OMNI',
    name: 'Hall Omnisport',
    type: 'infrastructure',
    status: 'active',
    img_url: img1,
    parent_id: null,
    color: '#3ac47d',
  },
  {
    id: 5,
    checked: false,
    code: 'OMNI-1',
    name: 'Hall Omnisport - T1',
    type: 'infrastructure',
    status: 'active',
    img_url: img1,
    parent_id: 4,
    color: '#3ac47d',
  },
  {
    id: 6,
    checked: false,
    code: 'OMNI-2',
    name: 'Hall Omnisport - T2',
    type: 'infrastructure',
    status: 'active',
    img_url: img1,
    parent_id: 4,
    color: '#3ac47d',
  },
  {
    id: 7,
    checked: false,
    code: 'OMNI-3',
    name: 'Hall Omnisport - T3',
    type: 'infrastructure',
    status: 'active',
    img_url: img1,
    parent_id: 4,
    color: '#3ac47d',
  },
  {
    id: 8,
    checked: false,
    code: 'PISC',
    name: 'Piscine',
    type: 'infrastructure',
    status: 'active',
    img_url: img6,
    parent_id: null,
    color: '#16aaff',
  },
  {
    id: 9,
    checked: false,
    code: 'PISC-1',
    name: 'Piscine - C1',
    type: 'infrastructure',
    status: 'active',
    img_url: img6,
    parent_id: 8,
    color: '#16aaff',
  },
  {
    id: 10,
    checked: false,
    code: 'PISC-2',
    name: 'Piscine - C2',
    type: 'infrastructure',
    status: 'active',
    img_url: img6,
    parent_id: 8,
    color: '#16aaff',
  },
  {
    id: 11,
    checked: false,
    code: 'FOOT1',
    name: 'Terrain de footbal 1',
    type: 'infrastructure',
    status: 'active',
    img_url: img8,
    parent_id: null,
    color: '#3ac47d',
  },
  {
    checked: false,
    code: 'ATH',
    name: 'Piste d\'athlétisme',
    type: 'infrastructure',
    status: 'active',
    img_url: img7,
    parent_id: null,
    color: '#d92550',
  },

];

const fields = [
  // 'index',
  // {
  //   key: 'color', label: '', class: 'color',
  // },
  {
    key: 'checked', label: 'Check', class: 'check',
  },
  {
    key: 'img_url', label: 'Pic', class: 'avatar',
  },
  {
    key: 'code', label: '# Ref', class: 'code', sortable: true, sortDirection: 'desc',
  },
  {
    key: 'name', label: 'Full name', class: 'name', sortable: true, sortDirection: 'desc',
  },
  {
    key: 'type', label: 'Type', class: 'type', sortable: true, sortDirection: 'desc',
  },
  {
    key: 'status', label: 'Status', class: 'status', sortable: true, sortDirection: 'desc',
  },
  {
    key: 'actions', label: 'Actions', class: 'actions',
  },
];

const filters = {
  'search': true, 
  'status': true, 
  'resource_type': true, 
  'resource_tags': true,
  'more': true,
};

export default {
  components: {
    'font-awesome-icon': FontAwesomeIcon,
    BpcPageTop,
    BpcPageTitle,
    BpcTable,
    BpcFormCreateResource,
  },
  data: () => ({
    heading: 'Resources',
    subheading: 'Infrastructures, locker rroms, material and coaches',
    icon: '', // 'pe-7s-users icon-gradient bg-tempting-azure',
    avatar: '',
    breadcrumb: ['Dashboard', 'Resources'],
    links: ['Help', 'Settings'],
    actions: {
      delete: true, bulk: true, new: false, edit: false, actions: true,
    },
    items,
    fields,
    selection: [],
    filters,
  }),
  methods: {
    updateSelection(selection) {
      this.selection = selection;
    },
  },
};
</script>

<style>
.card-body {
  padding: 0 !important;
}
.card-title {
  padding: 1.25rem 0.825rem 0.5rem;
}
</style>
